import vhCheck from 'vh-check';

const vh = vhCheck();
document.documentElement.style.setProperty('--vh-offset', `${vh.offset}px`);
